import { Directive } from '@angular/core';
import { BusinessVehicleMetadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class BusinessVehicleMetadataComponentAbstract extends BaseMetadataComponent<BusinessVehicleMetadata> {}
